import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AiOutlineHeart, AiFillHeart } from 'react-icons/ai';
import { useAuth } from '../context/AuthContext';
import './Wishlist.css';
import '../components/Recommended.css';

const Wishlist = () => {
    const navigate = useNavigate();
    const { wishlist, removeFromWishlist, user } = useAuth();

    const handleRemove = (itemId) => {
        removeFromWishlist(itemId);
    };

    // Calculate discounted price for display
    const getDisplayData = (item) => {
        // Use originalPrice as base
        const originalPrice = item.originalPrice 
            ? (typeof item.originalPrice === 'string' ? parseInt(item.originalPrice.replace(/[₹,]/g, '')) : item.originalPrice)
            : 0;
        
        const discount = item.discount || 0;
        
        // If discountedPrice is already stored, use it; otherwise calculate
        const discountedPrice = item.discountedPrice
            ? (typeof item.discountedPrice === 'string' ? parseInt(item.discountedPrice.replace(/[₹,]/g, '')) : item.discountedPrice)
            : (discount > 0 ? Math.round(originalPrice - (originalPrice * discount / 100)) : originalPrice);
        
        return {
            originalPrice,
            discountedPrice,
            discount
        };
    };

    return (
        <div className="wishlist-page">
            <div className="page-header">
                <div className="greeting-section">
                    <h1>Hello, {user?.name || 'there'}! 👋</h1>
                    <p className="tagline">Your curated collection of beautiful textiles awaits</p>
                </div>
                <div className="wishlist-count">
                    <span>{wishlist.length} {wishlist.length === 1 ? 'item' : 'items'}</span>
                </div>
            </div>

            {wishlist.length > 0 ? (
                <div className="wishlist-grid">
                    {wishlist.map((item) => {
                        const displayData = getDisplayData(item);
                        return (
                            <div 
                                key={item.id} 
                                className="product-card"
                                onClick={() => navigate(`/product/${item.id}`, { state: { product: item } })}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="product-image-container">
                                    <img src={item.image} alt={item.title || item.name} className="product-image" />
                                    {displayData.discount > 0 && <div className="discount-badge">{displayData.discount}%</div>}
                                    <button 
                                        className="wishlist-btn"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleRemove(item.id);
                                        }}
                                    >
                                        <AiFillHeart size={20} color="#e63946" />
                                    </button>
                                </div>
                                <div className="product-info">
                                    <h3 className="product-title">{item.title || item.name}</h3>
                                    <div className="product-price">
                                        {displayData.discount > 0 ? (
                                            <>
                                                <span className="original-price">₹{displayData.originalPrice}</span>
                                                <span className="current-price">₹{displayData.discountedPrice}</span>
                                            </>
                                        ) : (
                                            <span className="current-price">₹{displayData.originalPrice}</span>
                                        )}
                                    </div>
                                    <div className={`product-stock ${item.inStock ? 'in-stock' : 'out-of-stock'}`}>
                                        {item.inStock ? '✓ In Stock' : '✗ Out of Stock'}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <div className="empty-wishlist">
                    <AiOutlineHeart size={80} />
                    <h2>Your wishlist is empty</h2>
                    <p>Save items you like to your wishlist</p>
                </div>
            )}
        </div>
    );
};

export default Wishlist;
